export const environment = {
  production: false,
  apiUrl: 'https://wcw6zaqp6e.execute-api.eu-central-1.amazonaws.com/dev',
  okta: {
    issuer: 'https://tecalliance-qa.oktapreview.com/oauth2/default',
    clientId: '0oaab90pisa5aKoqU0x7',
    redirectUri: 'https://dev.legal-blacklist.tecalliance.net/login/callback',
    postLogoutRedirectUri: 'https://dev.legal-blacklist.tecalliance.net/',
    scopes: ['openid', 'profile', 'email']
  }
};
